import React from 'react';
import { Row, Col } from 'antd';
import './banner.css';

export default function SunsetBanner() {
  return (
    <div className="sunset-banner">
      <Row justify="center" align="middle" style={{ width: '100%', margin: 0 }}>
        <Col xs={22} sm={22} md={22} lg={20} xl={18} xxl={16}>
          <div className="banner-content">
            <p className="banner-text">
              AYLA Bill Management will sunset on January 15, 2026. We're preparing something new for enterprise — stay tuned.
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
}
